"use client";

import { useMediaDescriptions } from "@/components/ui/MediaImage";
import { resolveMediaAlt } from "@/utils/media-descriptions";

/** A tile link without a heading is an empty anchor over the tile, named by its eyebrow, else by its picture's
 *  description in Medier (a context only client components read), else by `fallback`. */
export default function TileLink({
  href,
  newTab,
  eyebrow,
  imageUrl,
  fallback,
}: {
  href: string;
  newTab: boolean;
  eyebrow?: string;
  imageUrl?: string;
  fallback: string;
}) {
  const descriptions = useMediaDescriptions();
  const name =
    eyebrow?.trim() ||
    (imageUrl ? resolveMediaAlt(descriptions, imageUrl, "") : "") ||
    fallback;
  return (
    <a
      className="pf-card-link pf-mosaic-link"
      href={href}
      {...(newTab ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      aria-label={newTab ? `${name} (åbner i et nyt vindue)` : name}
    />
  );
}
